import React from "react";
import { useNavigate } from "react-router-dom";
import { AlertTriangle } from "lucide-react";

/**
 * Shown when a technician (or anyone acting on their behalf) tries to mark a
 * job "En Route" while that tech already has another open job (En Route / On
 * Site / In Progress). Admins get an "Override & continue" escape hatch;
 * everyone else must close the open job first.
 */
export default function OpenJobAlertModal({ jobId, isAdmin, mobile, onOverride, onClose }) {
  const navigate = useNavigate();

  const goToJob = () => {
    onClose();
    navigate(mobile ? `/mobile/jobs/${jobId}` : `/jobs?id=${jobId}`);
  };

  return (
    <div
      className="fixed inset-0 z-[300] bg-black/60 flex items-center justify-center p-4"
      data-testid="open-job-alert-modal"
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-full max-w-sm rounded-2xl bg-white shadow-2xl p-5"
      >
        <div className="h-11 w-11 rounded-full bg-rose-50 flex items-center justify-center mb-3">
          <AlertTriangle className="h-5 w-5 text-rose-600" />
        </div>
        <div className="text-[15px] font-bold text-slate-900 mb-1">Job is still open</div>
        <p className="text-[13.5px] text-slate-600 leading-relaxed">
          Job#{" "}
          <button
            onClick={goToJob}
            data-testid="open-job-alert-link"
            className="font-semibold text-blue-600 underline hover:text-blue-700"
          >
            {jobId}
          </button>{" "}
          is open and must be closed before accepting another job.
        </p>
        <div className="mt-4 flex items-center justify-end gap-2">
          {isAdmin && (
            <button
              onClick={onOverride}
              data-testid="open-job-alert-override"
              className="h-9 px-3 rounded-lg border border-amber-300 bg-amber-50 text-amber-700 text-[13px] font-semibold hover:bg-amber-100"
            >
              Override &amp; continue
            </button>
          )}
          <button
            onClick={onClose}
            data-testid="open-job-alert-ok"
            className="h-9 px-4 rounded-lg bg-slate-800 text-white text-[13px] font-semibold hover:bg-slate-900"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
}
